import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useUIColors } from '../../hooks/useTheme';

const AdministrationBackLink = ({ to = '/administracion', label = 'Volver a Administración' }) => {
  const ui = useUIColors();

  return (
    <div style={{ margin: '2px 0 10px' }}>
      <Link
        to={to}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          color: ui.interactive,
          textDecoration: 'none',
          fontSize: '12px',
          fontWeight: 700,
          lineHeight: 1.2,
        }}
      >
        <ArrowLeft size={14} strokeWidth={2.25} />
        {label}
      </Link>
    </div>
  );
};

export default AdministrationBackLink;
